import { render, staticRenderFns } from "./ContentDeliveryRateList.vue?vue&type=template&id=05f49906&scoped=true"
import script from "./ContentDeliveryRateList.vue?vue&type=script&lang=js"
export * from "./ContentDeliveryRateList.vue?vue&type=script&lang=js"
import style0 from "./ContentDeliveryRateList.vue?vue&type=style&index=0&id=05f49906&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f49906",
  null
  
)

export default component.exports